import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["scope"];
import UILockBadge from 'UIComponents/badge/UILockBadge';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LockedNotificationsToggle = _ref => {
  let {
      scope
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    openUpgradeModal
  } = useUpgradeModal('workflows-monitoring-notifications');
  const hasAnomalyNotificationsScope = useHasScope(scope);
  const lockedProps = hasAnomalyNotificationsScope ? {} : {
    onClick: openUpgradeModal
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Toggle, Object.assign({}, restProps, lockedProps)), !hasAnomalyNotificationsScope && /*#__PURE__*/_jsx(UILockBadge, {})]
  });
};
export default LockedNotificationsToggle;